import axios from "axios";

export default function envorinment(isTestMode) {
  if (isTestMode) {
    return axios.create({
      baseURL: process.env.REACT_APP_SERVER_HML_URL,
      headers: {
        "Content-Type": "application/json",
        "mrpay-api-id": process.env.REACT_APP_SERVER_HML_ID,
        "mrpay-api-key": process.env.REACT_APP_SERVER_HML_KEY,
      },
    });
  } else {
    return axios.create({
      baseURL: process.env.REACT_APP_SERVER_PROD_URL,
      headers: {
        "Content-Type": "application/json",
        "mrpay-api-id": process.env.REACT_APP_SERVER_PROD_ID,
        "mrpay-api-key": process.env.REACT_APP_SERVER_PROD_KEY,
      },
    });
  }
}
